// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2pRdH","rootCenter":"LoadMoreObserver_rootCenter__XDLf6","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__W_Ymz"};